import React from "../../../_snowpack/pkg/react.js";
import styles from "./MyProjectsPage.module.css";
const MyProjectsPage = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.container
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.workingText
  }, " Currently no projects, but keep posted for when I update!"));
};
export default MyProjectsPage;
